module.exports = __webpack_public_path__ + "static/media/kostspec.se.84046c68.png";